import { useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  getFundManagersList,
  getIMAccess,
  IMAccess,
  UpdateFundManager,
} from '../../redux-store/actions/userManagement';
import { AddFundManagerRequestBody, FundManager } from '../../redux-store/types/api-types';
import { ColumnType } from '../DataTable';
import { useHistory } from 'react-router';
import UserMgmtListPage, {
  NameLinkCell,
  buildAccessColumn,
  buildActionsColumn,
  formatPhone,
  formatUserName,
  matchesUserSearch,
} from './UserMgmtListPage';

function FundManagers(): JSX.Element {
  const dispatch = useDispatch();
  const history = useHistory();
  const [accessForEditAdd, setAccessForEditAdd] = useState(false);

  return (
    <UserMgmtListPage<FundManager>
      loadData={async () => {
        const res = (await dispatch(getFundManagersList())) as unknown as FundManager[];
        const access = (await dispatch(getIMAccess())) as unknown as IMAccess;
        setAccessForEditAdd(access.fundManagerAccess);
        return res || [];
      }}
      searchPlaceholder="Search for Investment Managers"
      inviteLabel="Add Investment Manager"
      showInvite={accessForEditAdd}
      onInvite={() => history.push('add-Invest-manager')}
      accessDisabled={!accessForEditAdd}
      filterRow={(row, q) =>
        matchesUserSearch(q, [
          formatUserName(row.user),
          row.user?.email,
          `${row.user?.countryCode || ''}${row.user?.phone || ''}`,
        ])
      }
      getColumns={({ onToggleAccess, accessDisabled }) => {
        const columns: ColumnType[] = [
          {
            header: 'Name',
            align: 'left',
            headerAlign: 'left',
            renderCell: (row: FundManager) => (
              <NameLinkCell
                label={formatUserName(row.user)}
                to={{ pathname: 'Invest-manager-details', state: { fundManagerId: row.id } }}
              />
            ),
          },
          {
            header: 'Email Id',
            align: 'left',
            headerAlign: 'left',
            valueGetter: (row: FundManager) => row.user.email || 'N/A',
          },
          {
            header: 'Mobile number',
            align: 'left',
            headerAlign: 'left',
            valueGetter: (row: FundManager) => formatPhone(row.user),
          },
          buildAccessColumn(onToggleAccess, accessDisabled),
          buildActionsColumn((row: FundManager) => [
            {
              label: 'View Details',
              icon: '/images/view-application.svg',
              to: { pathname: 'Invest-manager-details', state: { fundManagerId: row.id } },
            },
            {
              label: 'View Plans',
              icon: '/images/rm.svg',
              to: { pathname: 'IM-plans', state: { IMId: row.id } },
            },
          ]),
        ];
        return columns;
      }}
      onAccessChange={async (row, nextActive) =>
        (await dispatch(
          UpdateFundManager(row.id as number, {
            ...(row as unknown as AddFundManagerRequestBody),
            isActive: nextActive,
          })
        )) as unknown as FundManager
      }
    />
  );
}

export default FundManagers;
